import { Injectable } from '@angular/core';
import { ExportExecutableParams } from '../export.model';
import { ExportResolver } from './export-resolver.model';
import { SPExportExcelService } from './sp-export-excel';

@Injectable()
export class SPExportResolver implements ExportResolver<ExportExecutableParams, boolean> {
  constructor(private exportService: SPExportExcelService) {}

  resolve(params: ExportExecutableParams) {
    return this.exportService.execute(params);
  }
}
